import { observer } from 'mobx-react-lite';
import React, { useCallback, useContext, useEffect } from 'react';
import { useLocation } from 'react-router';
import { RootStoresContext } from '../../stores/RootStore';
import SearchContent from './SearchContent';

const Search: React.FC = observer(() => {
  const rootStore = useContext(RootStoresContext);
  const location = useLocation();

  const fetchSearchPage = useCallback(() => {
    rootStore.pageStore.setCurrentPage(location.pathname);
  }, [rootStore.pageStore, location.pathname]);

  useEffect(() => {
    fetchSearchPage();
  }, [fetchSearchPage]);

  return <SearchContent />;
});

export default Search;
